import { Tooltip as ComponentsTooltip, IconButton, TooltipContent, TooltipTrigger } from "@bcc-ui/ui-components";
import React from "react";
import { useTranslation } from "react-i18next";

import style from "./copy-to-clipboard.scss";
import PlainCopy from "components/icons/PlainCopy";
import Tooltip from "components/tooltip/Tooltip";

interface Props {
    value: string;
    testId?: string;
    isNewTable?: boolean;
    iconColor?: string;
}

const CopyToClipboard = (props: Props): React.JSX.Element => {
    const { t } = useTranslation();
    const [copied, setCopied] = React.useState(false);
    const copyToClipboard = () => {
        navigator.clipboard.writeText(props.value);
        setCopied(true);
    };
    return props.isNewTable ? (
        <ComponentsTooltip>
            <TooltipContent>{copied ? t("Common.copied") : t("Common.copyToClipboard")}</TooltipContent>
            <TooltipTrigger>
                <IconButton
                    onClick={copyToClipboard}
                    className={style.plainCopyIcon}
                    data-testid={props.testId}
                    onMouseLeave={() => {
                        setCopied(false);
                    }}
                >
                    <PlainCopy color={props.iconColor} />
                </IconButton>
            </TooltipTrigger>
        </ComponentsTooltip>
    ) : (
        <Tooltip content={copied ? t("Common.copied") : t("Common.copyToClipboard")}>
            <button
                onClick={copyToClipboard}
                className={style.plainCopyIcon}
                data-testid={props.testId}
                onMouseLeave={() => {
                    setCopied(false);
                }}
                type="button"
            >
                <PlainCopy color={props.iconColor} />
            </button>
        </Tooltip>
    );
};

export default CopyToClipboard;
